<template>
  <div class="proveedor-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card no-header>
          <b-tabs @input='setTabIndex' justified>
            <b-tab title="Datos del Proveedor" active>
              <b-table 
                  small 
                  responsive="sm" 
                  :class="{ registro: true, 'datos-objeto': true }"
                  :busy="tableBusy"
                  :items="proveedorDatos" 
                  :fields="campos">
                <template v-slot:cell(valor)="data">
                  {{ formattedData(data.item) }}
                </template>
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>              
              </b-table>
            </b-tab>

            <b-tab title="Cuentas Bancarias">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :items="proveedorBancosCuentasDatos" 
                  :fields="proveedorBancosCuentasFields">
                <template v-slot:cell(opciones)="data">
                  <b-dropdown
                      v-if="accesoEdit"
                      variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="editarBancoCuenta(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos de la Cuenta</b-dropdown-item>
                    <b-dropdown-item @click.stop="borrarBancoCuenta(data.item)">
                      <i class="fa fa-edit"></i>Borrar Cuenta</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="Evaluaciones">
              <b-table hover
                  responsive="sm" 
                  :class="{ registro: true, 'datos-objeto': true }"
                  :items="proveedorEvaluacionesDatos" 
                  :fields="campos">
                <template v-slot:cell(valor)="data">
                  {{ formattedData(data.item) }}
                </template>
              </b-table>

              <br>

              <b-table hover
                  responsive="sm" 
                  :class="{ registro: true, evaluaciones: true }"
                  :items="proveedorEvaluaciones" 
                  :fields="proveedorEvaluacionesFields">
                <template v-slot:cell(fechaEvaluacion)="data">
                  {{ data.item.fechaEvaluacion | fecha }}
                </template>
                <template v-slot:cell(calificacion)="data">
                  <app-rating
                    :calificacion="data.item.calificacion">
                  </app-rating>
                </template>
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <!-- <b-dropdown-item @click.stop="editarBancoCuenta(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos de la Cuenta</b-dropdown-item> -->
                    <b-dropdown-item
                        :disabled="!opcionBorrarEvaluacion"
                        @click.stop="borrarEvaluacion(data.item)">
                      <i class="fa fa-remove"></i>Borrar Evaluación</b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:cell(detailShowing)="row">
                  <b-btn class="detailShowing" 
                      size="sm" 
                      @click.stop="row.toggleDetails">
                    {{ ( row.detailsShowing) ? '-' : '+' }}
                  </b-btn>            
                </template>

                <template v-slot:row-details="row">
                  <div v-if="row.item.calificacionAtencionCliente != 0
                      || row.item.calificacionTiempoEntrega != 0
                      || row.item.calificacionCostos != 0
                      || row.item.calificacionCalidad  != 0
                      || row.item.calificacion == 0">
                    <b-row>
                      <b-col cols="3">
                        <p class="descripcion">Atención al Cliente</p>
                      </b-col>
                      <b-col cols="9">
                        <app-rating
                          :calificacion="row.item.calificacionAtencionCliente">
                        </app-rating>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="3">
                        <p class="descripcion">Tiempo de Entrega</p>
                      </b-col>
                      <b-col cols="9">
                        <app-rating
                          :calificacion="row.item.calificacionTiempoEntrega">
                        </app-rating>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="3">
                        <p class="descripcion">Costos</p>
                      </b-col>
                      <b-col cols="9">
                        <app-rating
                          :calificacion="row.item.calificacionCostos">
                        </app-rating>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="3">
                        <p class="descripcion">Calidad</p>
                      </b-col>
                      <b-col cols="9">
                        <app-rating
                          :calificacion="row.item.calificacionCalidad">
                        </app-rating>
                      </b-col>
                    </b-row>
                  </div>

                  <div v-if="row.item.observaciones != ''"> 
                    <b-row>
                      <b-col cols="12">
                        <p class="descripcion">{{ row.item.observaciones }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </b-table>

              <nav>
                <b-pagination size="sm" 
                  :total-rows="totalRegistros" 
                  :per-page="registrosPorPagina" 
                  v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
              </nav>
            </b-tab>

            <b-tab title="Etiquetas">
              <b-row>
                <b-col>
                  <template  v-for="{ id, nombre } in proveedorEtiquetasDatos">
                    <b-badge :key="id" variant="primary">
                      {{ nombre }}
                      <i v-if="accesoEdit" class="fa fa-times" @click="borrarEtiqueta(id)"></i>
                    </b-badge>                      
                  </template>  
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="accesoEdit"
              @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Proveedor</b-dropdown-item>

          <b-dropdown-item 
              v-if="tabIndex == 1 && accesoEdit"
              @click.stop="agregarBancoCuenta"> 
            <i class="fa fa-plus"></i>Agregar Cuenta Bancaria</b-dropdown-item>

          <!-- <b-dropdown-item @click.stop="agregarEvaluacion" 
              v-if="tabIndex == 2 & opcionAgregarEvaluacion">
            <i class="fa fa-plus"></i>Agregar Evaluación</b-dropdown-item> -->

            <b-dropdown-item 
              v-if="tabIndex == 3 && accesoEdit"
              @click.stop="agregarEtiqueta">
            <i class="fa fa-plus"></i>Agregar Etiqueta</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="etiquetaModal"
        title="Etiqueta"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-nombre
        @save="saveEtiqueta"
        @cancelar="cancelarEtiqueta">
      </app-nombre>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Nombre from  '../shared/nombreModal.vue';
import Rating from  '../shared/rating.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'proveedor/getField',
  mutationType: 'proveedor/updateField',
});

export default {
  name: 'ProveedorDatos',
  components: {
    appNombre: Nombre,
    appRating: Rating,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      proveedorBancosCuentasFields: [
        {
          key: 'banco',
          sortable: true
        },
        {
          key: 'cuentaNumero',
          label: 'Nro. Cuenta',
          sortable: true
        },
        {
          key: 'cbu',
          label: 'CBU',
          sortable: true
        },
        {
          key: 'cbuAlias',
          label: 'Alias CBU',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      proveedorEtiquetasFields: [
        {
          key: 'nombre',
          label: 'Etiqueta',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      proveedorEvaluacionesFields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'fechaEvaluacion',
        },
        {
          key: 'calificacion',
          label: 'Calificación',
          // class: 'text-right'
        },
        { 
          key: 'referenciaNumero',
          label: 'Nro.Orden / Nro.Remito' 
        },
        { key: 'referencia' },
        // {
        //   key: 'ordenProveedorId',
        //   label: 'Nro.Orden',
        // },
        // {
        //   key: 'presupuestoNumero',
        //   label: 'Nro.Presupuesto',
        // },
        // {
        //   key: 'presupuestoInterno',
        // },
        {
          key: 'usuario',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tabIndex: 0,
      tableBusy: false,
      opcionBorrarEvaluacion: false,
      accesoEdit: false
    }
  },
  computed: {
    ...mapFields([
      'proveedorDatos',
      'proveedorBancosCuentasDatos',
      'proveedorEtiquetasDatos',
      'proveedorEvaluacionesDatos',
      'proveedorEvaluaciones',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },  
  created() {
    this.id= this.$route.params.id

    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
        this.opcionBorrarEvaluacion = true;
        break;
    }

    let route = this.$router.resolve({ name: 'ProveedorEdit', params: { 'id': -1 } }).route;
    this.accesoEdit = Boolean(this.$store.getters['user/tieneAcceso'](route));

    this.tableBusy = true;
    this.$store.dispatch('proveedor/getProveedorDatos', this.id)
      .then(() => {
        this.tableBusy = false;
        this.getEvaluaciones();
      })
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    getEvaluaciones() {
      // this.tableBusy = true;
      this.$store.dispatch('proveedor/getEvaluaciones')
        // .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack() {
      this.$router.go(-1)
    },
    editar() {
      if (this.accesoEdit) {
        this.$router.push({ name: 'ProveedorEdit', 
                            params: { id: this.id }})
      }
    },
    agregarBancoCuenta() {

    },
    editarBancoCuenta(item) {

    },
    borrarBancoCuenta(item) {

    },
    borrarEvaluacion(item) {
      if (this.opcionBorrarEvaluacion) {
        this.showModalConfirm('¿Desea borrar la evaluación seleccionada?', 
              this.borrarEvaluacionSeleccionada.bind(this, item.id), 'Si', null, 'No')
      }
    },
    borrarEvaluacionSeleccionada(evaluacionProveedorId) {
      this.showSpinner();
      this.$store.dispatch('evaluacionesProveedores/delete', evaluacionProveedorId)
        .then(() => {
          return this.$store.dispatch('proveedor/getProveedorEvaluacionesDatos');
        })
        .then(() => this.getEvaluaciones())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    agregarEtiqueta() {
      if (this.accesoEdit) {
        this.$refs.etiquetaModal.show();
      }
    },
    saveEtiqueta(params) {
      this.$refs.etiquetaModal.hide();

      params.proveedorId = this.id;

      this.showSpinner();
      this.$store.dispatch('proveedor/addEtiqueta', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarEtiqueta() {
      this.$refs.etiquetaModal.hide();
    },
    borrarEtiqueta(proveedorEtiquetaId) {
      if (this.accesoEdit) {
        this.showModalConfirm('¿Desea borrar la etiqueta seleccionada?', 
              this.borrarEtiquetaSeleccionada.bind(this, proveedorEtiquetaId), 'Si', null, 'No')
      }
    },
    borrarEtiquetaSeleccionada(proveedorEtiquetaId) {
      let params = {
        proveedorId: this.id,
        proveedorEtiquetaId
      }
      this.showSpinner();
      this.$store.dispatch('proveedor/deleteEtiqueta', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getEvaluaciones() 
      }
    },    
  }    
}
</script>

<style>
  .proveedor-datos .registro table thead th {
    border-top: none;
  }
  .proveedor-datos .registro.datos-objeto table td[aria-colindex="1"] {
    width: 30%;
  }
  .proveedor-datos .registro.datos-objeto table td[aria-colindex="2"] {
    width: 70%;
  }
  .proveedor-datos .registro.evaluaciones table td {
    vertical-align: middle;
    border-top: 1px solid #c8ced3 !important;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="1"],
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="7"] {
    width: 30px;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="2"] {
    width: 12%;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="3"] {
    width: 10%;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="4"] {
    width: 20%;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="5"] {
    width: 30%;
  }
  .proveedor-datos .registro.evaluaciones table td[aria-colindex="6"] {
    width: calc(28% - 60px);
  }
  .proveedor-datos .registro.evaluaciones table p.descripcion {
    margin-bottom: 5px;
    padding-left: 15px;
    width: 50%;
    white-space: pre-wrap;
  }

  /* .proveedor-datos .rating .star {
    margin-right: 5px;
  } */

  .proveedor-datos .badge {
    padding: 5px 12px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .proveedor-datos .badge i {
    margin-left: 5px;
    cursor: pointer;
  }
</style>